import React from 'react';
import StatusBadge from './StatusBadge';
import { FaEnvelope, FaLinkedin, FaMicrophone, FaFileAlt } from "react-icons/fa";
import StatusTooltip from './StatusTooltip';
import ProgressTooltip from './ProgressTooltip';
import CampaignPopup from './CampaignPopup';

const ProspectsTableRow = ({ prospect, isSelected, onRowSelect, onGenerate, onReview, onSend, onSendLinked }) => {
  const { 
    company_id, company_name, industry, rep_name, rep_title, avatar_img,
    email_confirmation_status_id, linkedin_status_id, voice_status_id, proposal_status_id,
    outreach_progress, linkedin_progress, voice_progress, proposal_progress
  } = prospect;

  return (
    <tr className="hover:bg-slate-50 transition-colors">
      <td className="p-4">
        <input type="checkbox" checked={isSelected} onChange={() => onRowSelect(company_id)} className="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"/>
      </td>
      <td className="p-4">
        <div className="font-medium text-slate-900">{company_name}</div>
        <div className="text-slate-500">{industry}</div>
      </td>
      <td className="p-4">
        <div className="flex items-center gap-3">
          <img className="h-10 w-10 rounded-full object-cover bg-slate-200" src={avatar_img} alt={`${rep_name}'s avatar`} onError={(e) => { e.target.style.display = 'none'; }} />
          <div>
            <div className="font-medium text-slate-900">{rep_name}</div>
            <div className="text-slate-500">{rep_title}</div>
          </div>
        </div>
      </td>
      {/* <td className="p-4 text-slate-700">
        <ProgressTooltip
          emailProgress={outreach_progress}
          linkedinProgress={linkedin_progress}
          voiceProgress={voice_progress}
          proposalProgress={proposal_progress}
        />
      </td>
      <td className="p-4">
        <StatusTooltip
          emailStatus={email_confirmation_status_id}
          linkedinStatus={linkedin_status_id}
          voiceStatus={voice_status_id}
          proposalStatus={proposal_status_id}
        />
      </td> */}

      <td className="p-4 relative">
        <CampaignPopup
          emailStatus={email_confirmation_status_id}
          linkedinStatus={linkedin_status_id}
          voiceStatus={voice_status_id}
          proposalStatus={proposal_status_id}
          emailProgress={outreach_progress}
          linkedinProgress={linkedin_progress}
          voiceProgress={voice_progress}
          proposalProgress={proposal_progress}
        />
      </td>



      <td className="p-4">
        <div className="flex items-center gap-2">
          <button 
            onClick={() => onGenerate(company_id)} 
            className="px-3 py-1 text-xs font-semibold text-slate-700 bg-white rounded-md border border-slate-300 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Generate
          </button>

          <button 
            onClick={() => onReview(company_id)} 
            className="px-3 py-1 text-xs font-semibold text-slate-700 bg-white rounded-md border border-slate-300 hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Review
          </button>

          {/* Email */}
          <button 
            onClick={() => onSend(company_id)} 
            className="p-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            <FaEnvelope />
          </button>

          {/* LinkedIn */}
          <button 
            onClick={() => onSendLinked(company_id)} 
            className="p-2 text-white bg-blue-800 rounded-md hover:bg-blue-900"
          >
            <FaLinkedin />
          </button>

          {/* Voice Note */}
          <button 
            // onClick={() => onSendVoice(company_id)} 
            onClick={() => alert('Voice Note feature coming soon!')} 
            className="p-2 text-white bg-green-600 rounded-md hover:bg-green-700"
          >
            <FaMicrophone />
          </button>

          {/* Proposal */}
          <button 
            // onClick={() => onSendProposal(company_id)} 
            onClick={() => alert('Proposal feature coming soon!')} 
            className="p-2 text-white bg-purple-600 rounded-md hover:bg-purple-700"
          >
            <FaFileAlt />
          </button>
        </div>
      </td>

    </tr>
  );
};

export default ProspectsTableRow;